import { ProductOrBrand } from "./alternativeTypes";

export const servicesProducts: ProductOrBrand[] = [

  {
    name: "Google",
    ownerCountry: "US",
    categories: ["services", "search-engine"],
  },
  {
    name: "Gmail",
    ownerCountry: "US",
    categories: ["services", "email"],
  },
  {
    name: "Google Maps",
    ownerCountry: "US",
    categories: ["services", "maps"],
  },
  {
    name: "Microsoft 365",
    ownerCountry: "US",
    categories: ["services", "office-suite"],
  },
  {
    name: "ChatGPT",
    ownerCountry: "US",
    categories: ["services", "llm"],
  },
  {
    name: "Qwant",
    ownerCountry: "FR",
    categories: ["services", "search-engine"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Qwant"],
  },
  {
    name: "Ecosia",
    ownerCountry: "DE",
    categories: ["services", "search-engine"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Ecosia"],
  },
  {
    name: "Proton Mail",
    ownerCountry: "CH",
    categories: ["services", "email"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Proton_Mail"],
  },
  {
    name: "Fastmail",
    ownerCountry: "AU",
    headquarterIn: "AU",
    availableIn: ["UK", "FR", "DE", "IT", "ES", "NL", "SE", "NO", "DK", "FI", "IE"],
    comments: "Australian email hosting company offering privacy-focused paid email services with no user tracking. Founded in 1999, Fastmail provides reliable and secure email solutions for individuals and businesses. ",
    categories: ["services", "email"],
    sourceLinks: ["https://www.fastmail.com/company/about/", "https://en.wikipedia.org/wiki/Fastmail"]
  },
  {
    name: "mailbox",
    ownerCountry: "DE",
    categories: ["services", "email"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mailbox.org"],
  },
  {
    name: "HERE WeGo",
    ownerCountry: "NL",
    categories: ["services", "maps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Here_WeGo"],
  },
  { 
    name: "TomTom AmiGO", 
    ownerCountry: "NL", 
    headquarterIn: "NL", 
    availableIn: ["AL", "AM", "AT", "BE", "BA", "BG", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "MD", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SI", "ES", "SE", "CH", "TR", "UA", "UK"], 
    comments: "Free mobile satellite navigation software offering turn-by-turn navigation, speed camera alerts, and real-time traffic information, compatible with Android Auto and CarPlay.", 
    categories: ["services", "maps"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/TomTom_AmiGO", "https://www.tomtom.com/en_gb/navigation/mobile-apps/"] 
  },
  {
    name: "Seznam.cz",
    ownerCountry: "CZ",
    headquarterIn: "CZ",
    availableIn: ["CZ"],
    comments: "Czech internet portal and search engine offering various services including email, maps, news, and more. Owned by Helifreak Limited which is a cypriot holding company, without having confirmed the owners it seems to be owned by a Czech owner.",
    categories: ["services", "search-engine", "email", "maps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Seznam.cz", "https://o.seznam.cz/en/about-us/"]
  },
  {
    name: "Mapy.cz",
    ownerCountry: "CZ",
    headquarterIn: "CZ",
    availableIn: ["CZ", "PL", "DE", "IT"],
    comments: "Czech map portal and mobile app offering detailed maps, route planning, and navigation services for various modes of transportation, including hiking and cycling. Owned by Seznam.cz, who is owned by Helifreak Limited which is a cypriot holding company, without having confirmed the owners it seems to be owned by a Czech owner.",
    categories: ["services", "maps"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mapy.cz", "https://mapy.cz/"]
  },
  {
    name: "LibreOffice",
    ownerCountry: "DE",
    categories: ["services", "office-suite"],
    sourceLinks: ["https://en.wikipedia.org/wiki/LibreOffice"],
  },
  {
    name: "Mistral Le Chat",
    ownerCountry: "FR",
    categories: ["services", "llm"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Mistral_AI"],
  },
];